import * as React from "react"
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";



export type GameBlockProps = {

}

export type GameBlockStyle = Partial<{

}>

export function GameBlock<customBlockData, extra_images>(
    props: GameBlockProps,
    options?: { style?: GameBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
    return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
        mk_widget({
            run: _ => {
                return (<section className={`block block--text`}>
                    <div className={`block__inner container container--s spacing--m`}>
                        <div className={`block__content`}>
                            <div className={`block__text text--styled`}>
                                <iframe src="/game/index.html"
                                    width="1024px"
                                    height="768px"
                                    frameBorder="0"
                                    marginHeight={0}
                                    scrolling="no" />
                            </div>
                        </div>
                    </div>
                </section>
                );
            }
        })
}
